import { string, object, SchemaOf } from 'yup'

export interface ILoginSchema {
    password: string
    email: string
}

const loginSchema: SchemaOf<ILoginSchema> = object().shape({
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
    password: string().required('Preencha o campo com sua senha'),
})

export default loginSchema
